module.exports = __webpack_public_path__ + "img/util-tab-6-title.ba8df36e.svg";